import React from "react";
import PropTypes from "prop-types";
import { formViews } from "../../common/AccountForm";
import ActivateAccountBadge from "../../common/ActivateAccountBadge/ActivateAccountBadge";
import "./AccountPageActivateAccountBadge.scss";

const AccountPageActivateAccountBadge = ({ formView }) => {
    // Only render the badge above the activate account form
    if (formView === formViews.ACTIVATE_ACCOUNT) {
        return (
            <div className="account-page-activate-account-badge grid">
                <div className="col col--12">
                    <div className="account-page-activate-account-badge__container">
                        <ActivateAccountBadge />
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

AccountPageActivateAccountBadge.propTypes = {
    formView: PropTypes.string.isRequired,
};

export default AccountPageActivateAccountBadge;
